/**
 * Single source of truth for page sections: order, id, and label.
 * Used by NavBar, SectionSidebar, and Section wrapper.
 */
export const SECTIONS = [
  { id: 'home', label: 'Home', suit: '♠' },
  { id: 'about', label: 'About', suit: '♥' },
  { id: 'experience', label: 'Experience', suit: '♣' },
  { id: 'projects', label: 'Projects', suit: '♦' },
  { id: 'education', label: 'Education', suit: '♠' },
];
